import { redirect } from "react-router-dom";

export function action(){
    let local = localStorage.removeItem('auth_data');
    console.log(local)
    return redirect('/auth');
}